/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { IPlaceBalloon, IUserPermissions, EPermissionStatus, EPlotType } from '../../../core/models';

@Component({
  selector: 'fm-place-balloon',
  templateUrl: './place-balloon.component.html',
  styleUrls: ['./place-balloon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaceBalloonComponent {
  @Input()
  public balloon: IPlaceBalloon;
  @Input()
  public permissions: IUserPermissions;

  @Output()
  public editClicked = new EventEmitter<IPlaceBalloon>();
  @Output()
  public findNearestClicked = new EventEmitter<IPlaceBalloon>();
  @Output()
  public viewMetricsClicked = new EventEmitter<IPlaceBalloon>();

  public EPermissionStatus = EPermissionStatus;
  public EPlotType = EPlotType;

  public onFindNearest(): void {
    this.findNearestClicked.emit(this.balloon);
  }

  public onEdit(): void {
    this.editClicked.emit(this.balloon);
  }

  public onViewMetrics(): void {
    this.viewMetricsClicked.emit(this.balloon);
  }
}
